// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  const { get, isPlainObject, omit, isBoolean, isNil } = require('lodash/fp');

  var m = require('mobx');
  var PermissionDetail = require('logic/models/Izenda.PermissionDetail');
  var AccountInfo = require('logic/models/Izenda.AccountInfo');
  var UiState = require('logic/Izenda.UiState');

  function SecurityDetail() {
    var props = {
      permission: new PermissionDetail(),
      isLoaded: false
    };

    m.extendObservable(this, props);
  }

  /**
   * Populate data
   * @param {Object} permission
   * @param {Object} tenantDetail
   * @param {Boolean} isLoaded
   */
  SecurityDetail.prototype.populate = m.action(function(permission, tenantDetail, isLoaded) {
    this.getPermission(permission, get('permission', tenantDetail));
    this.permission.populateData(permission, this.permission.propsCloned, this.permission);
    this.isLoaded = isLoaded;
  });

  /**
   * Get permission
   * @param {Object} permission
   * @param {Object} tenantPermission
   */
  SecurityDetail.prototype.getPermission = function(permission, tenantPermission) {
    if (permission.fullReportAndDashboardAccess) {
      updatePermission(permission.reports, get('reports', tenantPermission));
      updatePermission(permission.dashboards, get('dashboards', tenantPermission));
      updatePermission(permission.access, get('access', tenantPermission));
      updatePermission(permission.scheduling, get('scheduling', tenantPermission));
      updatePermission(permission.emailing, get('emailing', tenantPermission));
      updatePermission(permission.exporting, get('exporting', tenantPermission));
    }

    function updatePermission(permission, tenantPermission) {
      for (var key in omit('tenantAccess', permission)) {
        var data = permission[key];
        var tenant = get(key, tenantPermission);

        if (isPlainObject(data)) {
          updatePermission(data, tenant);
        } else if (isBoolean(data)) {
          if (isNil(tenantPermission)) {
            permission[key] = data;
          } else {
            permission[key] = tenant;
          }
        }
      }
    }
  };

  /**
   * Clear data
   */
  SecurityDetail.prototype.clear = m.action(function() {
    this.permission = new PermissionDetail();
    UiState.currentUser = new AccountInfo();
    UiState.setTenantId(null, false, true);
    this.isLoaded = false;
  });

  var singleton = new SecurityDetail();
  module.exports = singleton;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SecurityDetail.js